import {connect} from "react-redux";
import StockTransfersPage from "./StockTransfersPage";
import * as StockTransferApiActions from "../../actions/StockTransferApiActions";
import * as ViewActions from "../../actions/ViewActions";

export default connect(null, {...StockTransferApiActions, ...ViewActions})(StockTransfersPage);
